<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.4、档位分析</h3>

        <div style="margin-top: 15px;">
            <el-row :gutter="20">
                <!-- 1. 各档位运行百分比饼图 -->
                <el-col :span="24">

                    <div class="chart-container" ref="pieChart"></div>

                    <div class="table-caption">图表4</div>
                </el-col>

                <!-- 2. 档位运行状态对比条形图 -->
                <el-col :span="24" style="margin-top: 20px;">

                    <div class="chart-container" ref="barChart"></div>

                    <div class="table-caption">图表5</div>
                </el-col>
            </el-row>
        </div>

        <div class="no-page-break-before"></div>

        <!-- 横向多列表格（完全匹配截图） -->
        <el-table :data="tableData" border :cell-style="cellStyle" :header-cell-style="headerCellStyle"
            style="width: max-content; min-width: 100%;">
            <!-- 转速列（首列） -->
            <el-table-column label="转速-档位" prop="Title" width="80" align="center" />
            <!-- 档位列（横向表头） -->
            <el-table-column v-for="(speed, idx) in speedHeaders" :key="idx" :label="speed.title" :prop="speed.key"
                align="center">
                <template slot-scope="scope">
                    {{ scope.row[speed.key] || '0.00' }}
                </template>
            </el-table-column>
            <!-- 累计列 -->
            <el-table-column label="累计" prop="累计" width="50" align="center" />
        </el-table>

        <div class="table-caption">数据表4</div>

        <!-- 说明文本 -->

    </div>
</template>

<script>

export default {
    name: "VehicleGearData",
    props: {
        engineRevStallChart: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        engineRevStallChart: {
            handler(newVal, oldVal) {
                if (newVal.Load.length > 0) {
                    this.initBarChart();
                }
                if (newVal.Stall.length > 0) {
                    this.renderChart();
                }
            },
            deep: true
        }
    },
    data() {
        return {
            speedHeaders: [{
                title: '六档', key: '6档'
            },
            { title: '五档', key: '5档' },
            { title: '四档', key: '4档' },
            { title: '三档', key: '3档' },
            { title: '二档', key: '2档' },
            { title: '一档', key: '1档' },
            ],
            // 表格数据：转速为行，档位为列
            tableData: [

            ]

        };
    },
    mounted() {

        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        transposeData(data) {
            // 1. 获取所有列名（指标名：Title、Total、B700...）
            const keys = Object.keys(data[0]);
            // 2. 获取所有行标题（阈值：>95、≤95...累计）
            const rowTitles = data.map(item => item.Title);

            // 3. 遍历列名，构建转换后的数据
            let transposed = keys.filter(key => key !== 'Title').map(key => {
                const newItem = { Title: this.renameIndicator(key) }; // 新数据的Title为原列名
                // 为每个阈值（原行）赋值
                rowTitles.forEach((title, index) => {
                    newItem[title] = data[index][key];
                });
                return newItem;
            });
            const totalRow = transposed.find(item => item.Title === 'Total');
            const nonTotalRows = transposed.filter(item => item.Title !== 'Total');
            // 重新拼接：非Total行 + Total行
            transposed = [...nonTotalRows, totalRow];

            return transposed;

        },
        renameIndicator(key) {
            if (key.startsWith('B')) {
                const num = key.slice(1);
                return `≤${num}`;
            } else if (key === 'H2400') {
                return '>2400';
            }
            return key; // Title、Total 保持不变
        },
        renderChart() {
            this.initPieChart();
            //数据处理
            const transposedData = this.transposeData(this.engineRevStallChart.Stall);
            this.tableData = transposedData
            // console.log(JSON.stringify(transposedData, null, 2));
        },
        headerCellStyle({ columnIndex }) {
            if (columnIndex === 0) return { 'background-color': '#f5f7fa' };
            return { 'background-color': '#e6f7ff' };
        },
        // 单元格样式：按数值着色，累计行加粗
        cellStyle({ row, columnIndex }) {
            if (columnIndex === 0) return {};
            if (row['Title'] === 'Total') return {};
            const speedColKey = this.speedHeaders[columnIndex - 1]?.key;
            const cellValue = row[speedColKey] || '0.00';
            const value = Number(cellValue);

            if (value == 0) return { 'background-color': '#ffffff' };
            else if (value > 0 && value <= 0.1) return { 'background-color': '#FFEFDB' };
            else if (value > 0.1 && value <= 0.5) return { 'background-color': '#EEE5DE' };
            else if (value > 0.5 && value <= 1) return { 'background-color': '#FFE4B5' };
            else if (value > 1 && value <= 1.5) return { 'background-color': '#E0FFFF' };
            else if (value > 1.5 && value <= 2) return { 'background-color': '#BFEFFF' };
            else if (value > 2 && value <= 2.5) return { 'background-color': '#AEEEEE' };
            else if (value > 2.5 && value <= 3) return { 'background-color': '#8DEEEE' };
            else if (value > 3 && value <= 4) return { 'background-color': '#CD950C' };
            else if (value > 4 && value <= 5) return { 'background-color': '#EE7600' };
            else if (value > 5 && value <= 8) return { 'background-color': '#CD4F39' };
            else if (value > 8) return { 'background-color': '#FF0000' };

            return {};
        },
        // 初始化饼图（各档位运行百分比）
        initPieChart() {
            const pieChart = echarts.init(this.$refs.pieChart);
            var data = []
            var colors = ['#87CEEB', '#FFD700', '#DA70D6', '#90EE90', '#4682B4', '#FFB6C1']

            this.engineRevStallChart.Stall.forEach(item => {
                if (item.Title != '累计')
                    data.push({ name: item.Title, value: item.Total, itemStyle: { color: colors[data.length] } })
            });

            const option = {
                title: {
                    text: '各档位运行百分比',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}%'
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center',
                    // formatter: '{name}: {value}%'
                },
                series: [
                    {
                        type: 'pie',

                        center: ['40%', '50%'],
                        data: data,
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}: {c}%'
                        },
                        labelLine: { show: true }
                    }
                ]
            };
            pieChart.setOption(option);
            this.$pieChart = pieChart;
        },

        // 初始化条形图（档位运行状态对比）
        initBarChart() {

            var data_1 = []
            var data_2 = []

            this.engineRevStallChart.Load.forEach(item => {
                data_1.push(parseFloat(item.EconomyRatio * 100).toFixed(2))
                data_2.push(parseFloat(item.NonEconomyRatio * 100).toFixed(2))

            });
            const barChart = echarts.init(this.$refs.barChart);
            const option = {
                grid: {
                    left: '3%',
                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                title: {
                    text: '档位的运行状态对比',
                    left: 'center',
                    textStyle: { fontSize: 16 }
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: '{b}: {c}%'
                },
                legend: {
                    data: ['经济区', '非经济区'],
                    bottom: 10,
                    left: 'center'
                },
                xAxis: {
                    type: 'value',
                    min: 0,
                    max: 100,

                    axisLabel: { formatter: '{value}%' }
                },
                yAxis: {
                    type: 'category',
                    data: ['一档', '二档', '三档', '四档', '五档', '六档'],
                    inverse: true // 反转Y轴，让“一档”在最下方（与原图一致）
                },
                series: [
                    {
                        name: '经济区',
                        type: 'bar',
                        stack: 'total', // 堆叠模式
                        barWidth: 15,
                        data: data_1,
                        itemStyle: { color: '#4682B4' }
                    },
                    {
                        name: '经济区',
                        type: 'bar',
                        stack: 'total',
                        barWidth: 15,
                        data: data_1,
                        itemStyle: { color: '#4682B4' }, label: {
                            show: true,
                            position: 'inside',
                            formatter: '{c}%' // 非经济区数值显示在条形右侧
                        }
                    },
                    {
                        name: '非经济区',
                        type: 'bar',
                        stack: 'total',
                        barWidth: 15,
                        data: data_2,
                        itemStyle: { color: '#FFD700' },
                        label: {
                            show: true,
                            position: 'inside',
                            formatter: '{c}%' // 非经济区数值显示在条形右侧
                        }
                    }
                ]
            };
            barChart.setOption(option);
            this.$barChart = barChart;
        },

        // 窗口缩放自适应
        handleResize() {
            this.$pieChart?.resize();
            this.$barChart?.resize();
        }

    }
};
</script>
<style scoped>
.chart-container {

    height: 400px;
    /* 饼图高度 */
}

/* 条形图容器单独设置高度 */
.el-card:nth-child(2) .chart-container {
    height: 300px;
}
</style>